<template>
  <div 
    v-if="show"
    class="modal-item-notes-v2-overlay fade-in"
    @click.self="handleClose"
  >
    <div class="modal-item-notes-v2">
      <!-- Header -->
      <div class="modal-item-notes-v2-header">
        <h3 class="modal-item-notes-v2-title">
          Add Special Instructions
        </h3>
        <button 
          @click="handleClose" 
          class="modal-item-notes-v2-close"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line
              x1="18"
              y1="6"
              x2="6"
              y2="18"
            />
            <line
              x1="6"
              y1="6"
              x2="18"
              y2="18"
            />
          </svg>
        </button>
      </div>
      
      <!-- Content -->
      <div class="modal-item-notes-v2-content">
        <textarea
          :value="notes"
          readonly
          placeholder="e.g. No onions, extra sauce..."
          class="modal-item-notes-v2-textarea"
        />
        
        <VirtualKeyboard 
          @keyPress="handleKeyPress"
          @backspace="handleBackspace"
          @enter="handleSave"
        />
      </div>

      <!-- Footer -->
      <div class="modal-item-notes-v2-footer">
        <button 
          @click="handleClose"
          class="modal-item-notes-v2-btn modal-item-notes-v2-btn-cancel"
        >
          Cancel
        </button>
        <button 
          @click="handleSave"
          class="modal-item-notes-v2-btn modal-item-notes-v2-btn-save"
        >
          Save Note
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VirtualKeyboard from './VirtualKeyboard.vue';

export default {
  name: 'ModalItemNotesV2',
  components: {
    VirtualKeyboard
  },
  data() {
    return {
      show: false,
      notes: ''
    };
  },
  computed: {
    itemNoteIndex() {
      return this.$store.getters['itemNote/index'];
    }
  },
  watch: {
    itemNoteIndex: {
      handler(newIndex, oldIndex) {
        if (newIndex !== null && newIndex !== undefined && newIndex !== oldIndex) {
          this.resetModal();
          this.show = true;
        } else if (newIndex === null || newIndex === undefined) {
          this.show = false;
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === 'modal-note-order-item') {
        this.resetModal();
        this.show = true;
      }
    });
    
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'modal-note-order-item') {
        this.show = false;
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
    this.$root.$off('bv::modal::hide');
  },
  methods: {
    resetModal() {
      this.notes = this.$store.getters['itemNote/notes'] || '';
    },
    handleKeyPress(key) {
      this.notes += key;
    },
    handleBackspace() {
      this.notes = this.notes.slice(0, -1);
    },
    handleSave() {
      this.$emit('saveNote', { notes: this.notes });
      // Clear the store index to hide the modal
      this.$store.commit('itemNote/setIndex', null);
      this.show = false;
      // Also hide the bootstrap modal if it exists (for compatibility)
      this.$nextTick(() => {
        if (this.$bvModal) {
          this.$bvModal.hide('modal-note-order-item');
        }
      });
    },
    handleClose() {
      // Clear the store index to hide the modal
      this.$store.commit('itemNote/setIndex', null);
      this.show = false;
      // Also hide the bootstrap modal if it exists (for compatibility)
      this.$nextTick(() => {
        if (this.$bvModal) {
          this.$bvModal.hide('modal-note-order-item');
        }
      });
    }
  }
};
</script>

<style scoped>
.modal-item-notes-v2-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
}

@media (min-width: 640px) {
  .modal-item-notes-v2-overlay {
    align-items: center;
  }
}

.fade-in {
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-item-notes-v2 {
  background: white;
  width: 100%;
  max-width: 512px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

.modal-item-notes-v2-header {
  padding: 16px;
  border-bottom: 1px solid #F3F4F6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #F9FAFB;
}

.modal-item-notes-v2-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 1.5;
  color: #1F2937;
  margin: 0;
}

.modal-item-notes-v2-close {
  padding: 8px;
  background: white;
  border-radius: 9999px;
  color: #6B7280;
  border: 1px solid #E5E7EB;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.modal-item-notes-v2-close:hover {
  color: #EF4444;
}

.modal-item-notes-v2-content {
  padding: 16px;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-item-notes-v2-textarea {
  width: 100%;
  height: 96px;
  padding: 16px;
  border: 1px solid #D1D5DB;
  border-radius: 12px;
  background: #F9FAFB;
  font-size: 18px;
  line-height: 1.5;
  resize: none;
  outline: none;
  font-family: inherit;
}

.modal-item-notes-v2-textarea:focus {
  outline: 2px solid #2563EB;
  outline-offset: 2px;
}

.modal-item-notes-v2-textarea::placeholder {
  color: #9CA3AF;
}

.modal-item-notes-v2-footer {
  padding: 16px;
  border-top: 1px solid #F3F4F6;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  background: #F9FAFB;
}

.modal-item-notes-v2-btn {
  padding: 12px;
  border-radius: 12px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  transition: all 0.1s;
  font-size: 16px;
}

.modal-item-notes-v2-btn:active {
  transform: scale(0.98);
}

.modal-item-notes-v2-btn-cancel {
  color: #4B5563;
  background: white;
  border: 1px solid #E5E7EB;
}

.modal-item-notes-v2-btn-save {
  color: white;
  background: #0F172A;
}

.modal-item-notes-v2-btn-save:active {
  background: #1E293B;
}
</style>
